import React from "react";
import classnames from "classnames";

const Spinner: React.FC<{
  width?: number;
  height?: number;
  padding?: boolean;
  color?: "green" | "yellow";
}> = ({ width = 65, height = 65, padding = true, color = "green" }) => (
  <div
    className={classnames("flex items-center justify-center", {
      "py-md": padding,
    })}
  >
    <svg
      className="spinner"
      width={width}
      height={height}
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={classnames("path", {
          "stroke-green": color === "green",
          "stroke-yellow": color === "yellow",
        })}
        fill="none"
        strokeWidth="6"
        strokeLinecap="round"
        cx="33"
        cy="33"
        r="30"
      ></circle>
    </svg>
    <style jsx global>
      {`
        :root {
          --spinner-offset: 187;
          --spinner-offset-50: 46.75;
          --spinner-duration: 1.4s;
        }
      `}
    </style>
    <style jsx>
      {`
        .spinner {
          animation: rotator var(--spinner-duration) linear infinite;
        }

        @keyframes rotator {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(270deg);
          }
        }

        .path {
          stroke-dasharray: 187;
          stroke-dashoffset: 0;
          transform-origin: center;
          animation: dash var(--spinner-duration) ease-in-out infinite;
        }

        @keyframes dash {
          0% {
            stroke-dashoffset: var(--spinner-offset);
          }

          50% {
            stroke-dashoffset: var(--spinner-offset-50);
            transform: rotate(135deg);
          }

          100% {
            stroke-dashoffset: var(--spinner-offset);
            transform: rotate(450deg);
          }
        }
      `}
    </style>
  </div>
);

export default Spinner;
